// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Prompt } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetActivePromptByAufgabeId(): (
  aufgabeId: string
) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId) =>
      (await getAPI()).prompts.getActivePromptByAufgabeId({ aufgabeId }),
    [getAPI]
  );
}
